import React from 'react';
import { SectionCard } from '../../../components/SectionCard';
import { FormInput } from '../../../components/form';
import { FormikRichTextEditor } from '../../../components';

export interface IProductTitleDescriptionSectionProps {
  disabled?: boolean;
}

/**
 * Title and description, in one named section with visible labels.
 *
 * Just those two, as drawn — the product type lives in "Pricing & inventory".
 *
 * Both fields were previously unlabelled boxes in separate untitled cards —
 * the title relied on its placeholder, which disappears the moment you type,
 * and the description had nothing at all. Naming them costs a line each and
 * removes the guesswork.
 */
export const ProductTitleDescriptionSection: React.FC<IProductTitleDescriptionSectionProps> = ({
  disabled = false,
}) => {
  return (
    <SectionCard title="Details" testId="product-details-section">
      <div className="space-y-5">
        <FormInput
          type="text"
          autoComplete="off"
          name="title"
          label="Title"
          disabled={disabled}
          data-testid="product-title-input"
        />
        <FormikRichTextEditor
          disabled={disabled}
          label="Description"
          showLabel
          // Where it ends up, then what survives the trip. The line said only
          // the second half, so a seller writing a description had nothing
          // telling them it is the storefront copy they are writing.
          footNote="Shown on your product page. Formatting: headings, lists and links."
          name="description"
          height={240}
          data-testid="product-description-input"
        />
      </div>
    </SectionCard>
  );
};
